//react and context
import { useEffect, useState, useContext } from 'react'

import { IntakeContext } from '../context/IntakeContext'

// @mui and icons
import {
  Fade,
  IconButton,
  Tooltip,
  Grid,
  Typography,
  Icon,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'
import financeImage from 'assets/images/finance-image.svg'

// custom components
import { OnboardingTile } from './OnboardingTile'
import { QuestionMarkSharp } from '@mui/icons-material'

const OnboardingMultiSelectTile = ({
  preHeader,
  header,
  subHeader,
  helpText,
  tileSize,
  questionArray,
}) => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  const optionList = questionArray.reduce((acc, item) => {
    acc[item.id] = intakeState?.[item.id]
    return acc
  }, {})

  const [options, setOptions] = useState(optionList)

  const toggleOption = (option) => {
    setOptions({ ...options, [option]: !options[option] })
  }

  useEffect(() => {
    const filtered = Object.fromEntries(
      Object.entries(options).filter(([key]) => key) // removes '' keys
    )
    updateIntakeStateAtKey(filtered)
  }, [options])

  const fieldMap = (data) => {
    return (
      <Grid container spacing={1} justifyContent="center" mb={0}>
        {data.map((question) => (
          <Grid item {...tileSize} key={question.optionLabel}>
            <OnboardingTile
              label={question.optionLabel}
              icon={question.optionIcon}
              imageURL={question.optionImageURL}
              active={options[question.id]}
              onClick={() => toggleOption(question.id)}
              className={question.className}
            >
              Test
            </OnboardingTile>
          </Grid>
        ))}
      </Grid>
    )
  }

  const [open, setOpen] = useState(
    window.location.search === '?onboardingStep=retirementGoals' ? true : false
  )
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Box sx={{ textAlign: 'left' }}>
        {preHeader !== false && (
          <Box>
            <Typography
              variant="subtitle1"
              fontSize={{ xs: '16px', sm: '20px' }}
            >
              {preHeader || ''}
            </Typography>
          </Box>
        )}
        {header !== false && (
          <Box mb={1}>
            <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
              {header || "Let's start with your basic information:"}
              {helpText !== '' ? (
                <Tooltip
                  TransitionComponent={Fade}
                  title={
                    helpText ||
                    'This helps us calculate your retirement benefits'
                  }
                  placement="top"
                  color="info"
                  enterTouchDelay={0}
                  leaveTouchDelay={3000}
                >
                  <IconButton size="small" color="dark">
                    <HelpIcon sx={{ marginTop: '-6px' }} />
                  </IconButton>
                </Tooltip>
              ) : (
                <></>
              )}
            </Typography>
          </Box>
        )}

        {subHeader !== false && (
          <Typography
            variant="body1"
            sx={{ lineHeight: '1.2' }}
            fontSize={{ xs: '16px', sm: '20px' }}
          >
            {subHeader || 'Let us know basic details about you!'}
          </Typography>
        )}

        <Box my={header !== false ? 4 : 0} mb={header !== false ? 4 : 1}>
          {fieldMap(questionArray)}
          {/* End New Replacement */}
        </Box>
      </Box>
    </>
  )
}

export default OnboardingMultiSelectTile
